import { Component, Input, OnDestroy, OnInit, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { MatSidenav } from '@angular/material/sidenav';
import { environment } from 'src/environments/environment';
import { BusDataService } from 'src/app/paginas/expedientesRepse/busDataService';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/@store/app.reducers';

@Component({
  selector: 'theme-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy, OnChanges {

  @Input() catalogoRutas = [];
  @Input() menuLateral = [];
  @Input() subtitulo : string = '';
  version = environment.appVersion || 0;

  subsidiariaSeleccionada = '';

  @ViewChild('sideBarSecundario') sdSecundario: MatSidenav;


  ultimaSesion: any= new Date();

  loaderSubs = new Subscription();
  ruta = "";

  tituloRespaldo = "";
  empresaSubs = new Subscription();


  // isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  //   .pipe(
  //     map(result => result.matches),
  //     shareReplay()
  //   );

  isHandset$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.Handset])
    .pipe(
      map(result => {
        if (window.innerWidth <= 1024 && !result.matches) {
          //console.log('lay pase');
          
          return true;
        }
        return result.matches;
      }),
      shareReplay()
    );

  
  menuLatIzqInf = [
    {
      titulo: 'Cerrar sesión',
      icono: 'exit_to_app',
      ruta: '/logout'
    }
  ];

  subsRutas = new Subscription();
  tituloRuta = null;
  datosRuta = null;

  constructor(private authService: AuthService,
              private router: Router,
              private notiService: NotificacionesService,
              private bus: BusDataService,
              private breakpointObserver: BreakpointObserver,
              private store: Store<AppState>) {
    this.subsRutas = this.router.events.subscribe(val => {
      //console.log("rutas del lado izquierdo", val);
      if (val instanceof NavigationEnd) {
        this.ruta = val.url;
        this.subtitulo = '';
        //console.log("catalogo de rutas", this.catalogoRutas);
        this.datosRuta = this.catalogoRutas.find(enc => val.url === enc.ruta);
        //console.log("rutas del lado izquierdo", this.datosRuta );
        this.tituloRuta = this.datosRuta ? this.datosRuta.titulo : '';
      }
    });
    this.loaderSubs = this.notiService.obtenerEstatusSbDerecho().subscribe(estatus => {
      if (estatus === null || estatus === undefined) return;
      estatus === 'Abrir' ? this.sdSecundario.open() : this.sdSecundario.close();
    })
  }
  ngOnInit(): void {
    const ventana$ = this.bus.getOrCreateSubject('tituloPeriodoMetadatos', "");

    ventana$.get.subscribe((val: any) => {
      this.tituloRespaldo = val;
    });

    this.empresaSubs = this.store.select('empresa').subscribe(empresa => {
      this.subsidiariaSeleccionada = empresa?.subsidiaria ?? '';
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.catalogoRutas ? !changes.catalogoRutas.firstChange : false){
      //console.log("catalogo rutas 2 ", this.catalogoRutas);
      this.datosRuta = this.catalogoRutas.find(enc => this.ruta === enc.ruta);
      //console.log("cambio de rutas", this.datosRuta);
      this.tituloRuta = this.datosRuta ? this.datosRuta.titulo : '';
    }
   

  
  }

  ngOnDestroy(): void {
    this.subsRutas.unsubscribe();
    this.loaderSubs.unsubscribe();
    this.empresaSubs.unsubscribe();
  }

  cerrarSesion(){ 
    this.authService.cerrarSesion(true);
  }

  cerrarSidebarSecundario(){
    this.notiService.cambiarEstatusSbDerecho('Cerrar');
  }

}
